import { instance } from "..";
import lttylApi from "../intercepter/keycloakInterceptor";

export const deepLinkService = {
  async createDeepLink(data) {
    // Call lttl.in/shortUrl/create with Keycloak token (handled by interceptor)
    const shortUrlResponse = await lttylApi.post("/shortUrl/create", {
      domainName: data.domain,
      url: data.url,
      label: "DeepLink",
      daysToExpire: 365,
    });

    const { shortUrl, expiryDate } = shortUrlResponse.data;

    // Then, save the dynamic link data to PHP backend
    return (
      await instance.post("/dynamicLink/create.php", {
        ...data,
        short_url: shortUrl,
        expiry_date: expiryDate,
        skip_lttl_call: true, // Tell PHP to skip calling lttl.in API
      })
    ).data;
  },
  async editDeepLink(data, id, shortCode) {
    return (
      await instance.post(
        `/dynamicLink/update.php?id=${id}&shortCode=${shortCode}`,
        data
      )
    ).data;
  },
  async getDeepLinkByDomain(domain) {
    return (
      await instance.get(
        `/dynamicLink/getDynamicLinkByDomain.php?domain=${domain}`
      )
    ).data;
  },
  async deleteDeepLink(Id) {
    return (await instance.delete(`/dynamicLink/delete.php?id=${Id}`)).data;
  },
};
